import { DetailedSource, SourceType } from "interfaces/entities/ticket";
import { IRule, IRuleTrigger, IRuleTriggerSourceType } from "store/entities/rules/interfaces";

const mapLegacySourceTypeToDetailedSource: Record<SourceType | "agent", DetailedSource[]> = {
  // Agent was a special case for the "Created manually" label in rules
  agent: [DetailedSource.CreatedManually, DetailedSource.Api],
  [SourceType.Api]: [DetailedSource.CreatedManually, DetailedSource.Api],
  [SourceType.Email]: [DetailedSource.Email],
  [SourceType.External]: [DetailedSource.ContactForm],
  [SourceType.Integration]: [DetailedSource.Chat],
  [SourceType.OpenWidget]: [DetailedSource.ContactWidget],
  [SourceType.Webflow]: [DetailedSource.Webflow],
  [SourceType.ChatBot]: [DetailedSource.ChatBot],
  [SourceType.WordPress]: [DetailedSource.WordPress],
};

// This mapping should be deleted after release of detailed sources
// and API switch to always respond with `detailedSourceType` type rule trigger, instead of `sourceType`
const mapSourceTypeTriggerToDetailedSourceTypeTrigger = (
  triggers: (IRuleTrigger | IRuleTriggerSourceType)[]
): IRuleTrigger[] => {
  return triggers.map(trigger => {
    if (trigger.type === "sourceType") {
      return {
        ...trigger,
        type: "detailedSourceType",
        in: trigger.in.flatMap(source => mapLegacySourceTypeToDetailedSource[source]),
      };
    }

    return trigger;
  });
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deserializeRule: (object: any) => IRule = object => {
  const { ID, licenseID } = object;

  return {
    id: ID,
    licenseId: licenseID,
    type: object.type,
    active: object.active,
    quantifier: object.quantifier,
    name: object.name,
    triggers: mapSourceTypeTriggerToDetailedSourceTypeTrigger(object.triggers),
    actions: object.actions,
    ordering: object.ordering,
    useCounter: object.useCounter,
    description: object.description || "",
    premadeType: object.premadeType || null,
  };
};
